import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminContent from './Content';
import AdminFilter from './Filter';
import DeleteModalForm from 'src/components/Items/DeleteModalForm';
import { useTypedSelector } from 'src/hooks/useTypeSelector';

const AdminPage: FC = () => {
  const navigate = useNavigate();
  const { role } = useTypedSelector(state => state.auth);
  const [tab, setTab] = useState(0);
  const [openEl, setOpenEl] = useState([false, false, false, false]);
  const [openDelArray, setOpenDelArray] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [arrayForDelete, setArrayForDelete] = useState<number[]>([]);
  const [searchByLocation, setSearchByLocation] = useState('');

  useEffect(() => {
    if (role !== 'admin') navigate('/');
  }, [role]);

  useEffect(() => {
    setOpenDelArray(false);
    setArrayForDelete([]);
  }, [tab]);

  const handleChangeModal = (isOpen: boolean) => {
    const elements = [...openEl];
    elements[tab] = isOpen;
    setOpenEl(elements);
  };

  return (
    <>
      <AdminFilter
        tab={tab}
        setTab={setTab}
        openDelArray={openDelArray}
        setOpenDelArray={setOpenDelArray}
        arrayForDelete={arrayForDelete}
        setArrayForDelete={setArrayForDelete}
        setOpenModal={setOpenModal}
        setSearchByLocation={setSearchByLocation}
        handleChangeModal={handleChangeModal}
      />
      <AdminContent
        tab={tab}
        search={searchByLocation}
        isDeleteArray={openDelArray}
        arrayForDelete={arrayForDelete}
        setArrayForDelete={setArrayForDelete}
        open={openEl}
        handleClose={() => handleChangeModal(false)}
      />
      <DeleteModalForm
        id={arrayForDelete}
        type={tab === 2 ? 'pickup details' : 'season price'}
        handleClose={() => setOpenModal(false)}
        open={openModal}
      />
    </>
  );
};
export default AdminPage;
